// extracted by mini-css-extract-plugin
export default {"maxTip":"src-pages-SalesCannelVersion-SalesChannelSettings-SalesChannelMiniProgramSetting-MiniProgramWebviewDomainName-css-module__maxTip--47hz-"};